import { render, staticRenderFns } from "./DemoGridArticlesSingle.vue?vue&type=template&id=52e5b05d&"
import script from "./DemoGridArticlesSingle.vue?vue&type=script&lang=js&"
export * from "./DemoGridArticlesSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports